// extracted by mini-css-extract-plugin
export default {"root":"CommonColorSelectOption-module-root-eHvZo","selected":"CommonColorSelectOption-module-selected-gHvjh","container":"CommonColorSelectOption-module-container-Ri28k"};